import { Box, Container, Typography, Button, Grid } from "@mui/material";
import SettingsSuggestTwoToneIcon from '@mui/icons-material/SettingsSuggestTwoTone';
import FormatShapesTwoToneIcon from '@mui/icons-material/FormatShapesTwoTone';
import AddHomeWorkTwoToneIcon from '@mui/icons-material/AddHomeWorkTwoTone';
import ArchitectureTwoToneIcon from '@mui/icons-material/ArchitectureTwoTone';
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';

const steps = [
  {
    id: 1,
    title: "Survey Planning",
    desc:
      "We conduct detailed site surveys and reserve assessments to identify high grade sand deposits. Our planning process ensures regulatory compliance, environmental responsibility, and efficient extraction strategies before operations begin.",
    icon: <AddHomeWorkTwoToneIcon sx={{fontSize:'40px'}}/>,
  },
  {
    id: 2,
    title: "Smart Extraction",
    desc:
      "Using advanced excavation equipment and controlled mining methods, we extract construction grade sand with precision. Every activity follows strict safety protocols and sustainable practices to protect surrounding land and water systems.",
    icon: <FormatShapesTwoToneIcon sx={{fontSize:'40px'}}/>,
  },
  {
    id: 3,
    title: "Quality Processing",
    desc:
      "Extracted sand is screened, washed, and graded to meet construction standards. We eliminate impurities, regulate particle consistency, and ensure material strength suitable for concrete, infrastructure, and structural applications.",
    icon: <SettingsSuggestTwoToneIcon sx={{fontSize:'40px'}}/>,
  },
  {
    id: 4,
    title: "Timely Delivery",
    desc:
      "With a reliable logistics network, we transport processed sand directly to project sites. Our delivery system ensures secure handling, punctual supply, and uninterrupted material flow for residential and commercial construction needs.",
    icon: <LocalShippingTwoToneIcon sx={{fontSize:'40px'}}/>,
  },
];

const WorkingProcess = () => {
  return (
    <Box
      sx={{
        position: "relative",
        py: { xs: 8, md: 12 },
        backgroundImage:
          "url(https://rstheme.com/products/wordpress/konstruk/wp-content/uploads/2022/03/konstruk-bg.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
      }}
    >
      {/* overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.65)",
        }}
      />

      <Container sx={{ position: "relative", zIndex: 2 }}>
        {/* Header */}
        <Grid container alignItems="center" spacing={4} mb={8}>
          <Grid size={{ xs: 12, md: 8 }}>
            <Typography
              variant="h3"
              fontWeight={700}
              sx={{ lineHeight: 1.2 }}
            >
              Our working process – how we work for our customers
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }} textAlign={{ xs: "left", md: "right" }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#fcb900",
                color: "#000",
                fontWeight: 600,
                px: 4,
                py: 1.5,
                "&:hover": {
                  backgroundColor: "#e0a800",
                },
              }}
            >
              Get In Touch
            </Button>
          </Grid>
        </Grid>

        {/* Steps */}
        <Grid container spacing={6}>
          {steps.map((step) => (
            <Grid key={step.id} size={{ xs: 12, sm: 6, md: 3 }}>
              <Box textAlign="center">
                {/* Icon circle */}
                <Box
                  sx={{
                    position: "relative",
                    width: 140,
                    height: 140,
                    mx: "auto",
                    mb: 3,
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                    color: "#53492c",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    // fontSize: 48,
                  }}
                >
                  {step.icon}

                  {/* Step number */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: -20,
                      left: "30%",
                      transform: "translateX(-50%)",
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      backgroundColor: "#fcb900",
                      color: "#ffffff",
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 18,
                    }}
                  >
                    {step.id}
                  </Box>
                </Box>

                <Typography variant="h6" fontWeight={600} mt={8} gutterBottom>
                  {step.title}
                </Typography>

                <Typography variant="body2" sx={{ opacity: 0.85, borderLeft:'1px solid #fec8106b', textAlign:'start', paddingLeft:'12px' }}>
                  {step.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
export default WorkingProcess;
